import { TemplateWrapper } from "@2u-landing-pages/components/TemplateWrapper";
import { ContentfulImageConfig } from "@2u-landing-pages/types";
import React from "react";
import { BentoCSSProperties, BentoProps, CustomCSSProperties } from "./Bento.types";
import { Default } from "./variations/Default";
import { Inline } from "./variations/Inline";

const renderVariation = (props: BentoProps, style?: BentoCSSProperties) => {
  switch (props.variation) {
    case "inline":
      return <Inline {...props} style={style} />;
    default:
      return <Default {...props} style={style} />;
  }
};

export const Bento: React.FC<BentoProps> = ({
  section_background_color,
  section_background_image,
  background_color,
  image_config,
  ...rest
}) => {
  const style: CustomCSSProperties = {};

  if (background_color) style["--extended-background-color"] = `var(${background_color})`;
  if (rest.tile_background_color) style["--tile-background-color"] = `var(${rest.tile_background_color})`;

  if (rest?.embedded) return renderVariation(rest, style);

  return (
    <TemplateWrapper
      padded
      backgroundColor={section_background_color}
      backgroundImage={section_background_image}
      image_config={image_config as unknown as ContentfulImageConfig}
      style={style}
    >
      {renderVariation(rest)}
    </TemplateWrapper>
  );
};
